<template>
  <div class="x-query">
    <ul class="query-content">
      <li v-for="(item, i) in formArr" :key="item.label" :class="[formArr.length<4?'normal-layout':'col4-layout']">
        <div class="label" :title="item.label">{{ item.label }}:</div>
        <IviewSelect
          transfer
          clearable
          v-model="form[item.key]"
          :optionList="Array.isArray(item.select)?item.select:item.select()"
          :placeholder="'请选择' + item.label"
          v-if="item.select"
        />
        <IviewDatePicker
          v-else-if="item.time"
          v-model="form[item.key]"
          type="daterange"
          separator=" 至 "
          v-bind="item.attrs"
          v-on="item.listeners"
        ></IviewDatePicker>
        <div v-else-if="item.slot"><slot :name="item.slot"></slot></div>
        <IviewInput v-else v-model.trim="form[item.key]" :placeholder="item.placeholder||'请输入' + item.label" clearable />
      </li>
    </ul>
    <div class="btns">
      <slot></slot>
      <IviewButton type='primary' @click="query">搜索</IviewButton>
      <IviewButton @click="reset">{{ btn2Text }}</IviewButton>
    </div>
  </div>
</template>
<script>
export default {
  name: "x-query",
  props: {
    formArr: {
      type: Array,
      default: () => []
    },
    form: {
      type: Object,
      default: () => ({})
    },
    btn2Text: {
      type: String,
      default: "重置"
    }
  },
  data() {
    return {}
  },
  methods: {
    query() {
      this.$emit("query", this.form)
    },
    reset() {
      if (this.btn2Text == "重置") {
        delete this.form.startTime
        delete this.form.endTime
        for (let i in this.form) {
          if (Array.isArray(this.form[i])) this.form[i] = []
          else this.form[i] = ""
        }
      }

      this.$emit("reset")
    }
  }
}
</script>

<style lang="less" scoped>
.x-query {
  // height: 94px;
  // width: 100%;
  // background: #ffffff;
  // box-shadow: 0px 2px 19px 0px rgba(201, 208, 228, 0.58);
  // border-radius: 4px;
  // padding: 0 30px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  .query-content {
    padding: 20px 0 0 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .col4-layout {
      display: flex;
      align-items: center;
      margin: 0 20px 20px;
      width: 360px;
      .label {
        text-align: right;
        margin-right: 4px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #474747;
        width: var(--label-width);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    li.normal-layout{
      display: flex;
      align-items: center;
      margin: 0 20px 20px;
      .label {
        text-align: right;
        margin-right: 4px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #474747;
      }
    }
  }
  .btns {
    width: 100%;
    height: 54px;
    border-top: 1px solid #f6f8fb;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 36px 0 0;
  }
  .el-primary {
    margin: 0 0 0 30px;
  }
  .el-default {
    margin-left: 20px;
  }
}
</style>
